import React, { useState } from 'react';
import axios from 'axios';
import { Base_Uri } from '../../Constant/BaseUri';
import { Container, Typography, TextField, Button, Alert, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const ForgotPasswordScreen = () => {
    const [employeeId, setEmployeeId] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const navigation = useNavigate()
    const handleForgotPassword = async () => {
        try {
            const response = await axios.post(`${Base_Uri}forgot-password`, { employeeId });
            setMessage(response.data.message);
            setError('');
            setTimeout(()=>{
                navigation("/")
            },5000)
        } catch (error) {
            setError(error.response?.data?.message || 'Something went wrong');
            setMessage('');
        }
    };

    return (
        <Container maxWidth="sm" style={{ marginTop: '50px' }}>
            <Paper elevation={3} style={{ padding: '30px', textAlign: 'center' }}>
                <Typography variant="h4" gutterBottom>Forgot Password</Typography>
                <TextField 
                    type='text' 
                    label='Employee ID' 
                    variant='outlined' 
                    fullWidth 
                    value={employeeId} 
                    onChange={(e) => setEmployeeId(e.target.value)} 
                    margin='normal' 
                />
                <Button 
                    variant='contained' 
                    color='primary' 
                    fullWidth 
                    onClick={handleForgotPassword}
                    style={{ marginTop: '20px' }}
                >
                    Send Reset Link
                </Button>
                {message && <Alert severity="success" style={{ marginTop: '20px' }}>{message}</Alert>}
                {error && <Alert severity="error" style={{ marginTop: '20px' }}>{error}</Alert>}
            </Paper>
        </Container>
    );
};

export default ForgotPasswordScreen;